const calcSummary = (datas, column) => {
    let summaryColumn;
    if (column.summary_type) {
        switch (column.summary_type) {
            case 'sum':
                var sumValue = 0;
                datas.forEach(el => {
                    if (el[column.field_name]) {
                        sumValue += getValue(el, column) || 0;
                    }
                });
                summaryColumn = sumValue;
                break;
            case 'avg':
                var totalValue = 0;
                var count = 0;
                datas.forEach(el => {
                    if (el[column.field_name]) {
                        count++;
                        totalValue += getValue(el, column) || 0;
                    }
                });
                summaryColumn = totalValue / count;
                break;
            case 'max':
                var maxValue = 0;
                datas.forEach(el => {
                    if (el[column.field_name]) {
                        const tmpValue = getValue(el, column) || 0;
                        if (tmpValue > maxValue) {
                            maxValue = tmpValue;
                        }
                    }
                });
                summaryColumn = maxValue;
                break;
            case 'min':
                var minValue;
                datas.forEach(el => {
                    if (el[column.field_name]) {
                        const tmpValue = getValue(el, column) || 0;
                        if (minValue === undefined || tmpValue < minValue) {
                            minValue = tmpValue;
                        }
                    }
                });
                summaryColumn = minValue;
                break;
            case 'count':
                summaryColumn = datas.length;
                break;
            default:
                if (summaryColumn) {
                    summaryColumn = '';
                }
                break;
        }
    } else {
        if (summaryColumn) {
            summaryColumn = '';
        }
    }
    return summaryColumn;
}

const getValue = (data, column) => {
    let value = data[column.field_name];
    if (column.dataFormat) {
        value = column.dataFormat.getValue(data[column.field_name]);
    }

    if (value) {
        switch (column.dataType) {
            case 'varchar':
                break;
            case 'double':
            case 'decimal':
            case 'float':
                value = parseFloat(value.toString().replace(/,/g, ''));
                break;
            case 'int':
                value = Number(value.toString().replace(/,/g, ''));
                break;
            default:
                // 暂时转为数字计算
                value = parseFloat(value.toString().replace(/,/g, ''));
                break;
        }
    }

    return value;
}

exports.calcSummary = calcSummary;